/**
 * Comment s'écrit la période d'une absence — UN SEUL endroit.
 *
 * La règle vivait en deux exemplaires, dans « Mes demandes » et « Mes congés ».
 * Le 30/09/2026, il a fallu corriger les deux à l'identique : la démonstration
 * du risque. Une troisième lecture de la même donnée (le calendrier) décide,
 * elle, d'autre chose — si un jour reste posable — et garde sa propre fonction.
 */

const dateFr = (iso: string): string => iso.split('-').reverse().join('/');

export interface PeriodeAffichable {
  date_debut: string;
  date_fin: string;
  debut_demi: string;
  fin_demi: string;
}

/**
 * « 12/03/2026 (matin) », « 12/03/2026 → 16/03/2026 ».
 *
 * Sur un seul jour, « matin → après-midi » couvre la journée entière : aucun
 * suffixe, sans quoi on annoncerait « (matin) » pour un jour compté en entier.
 */
export function periodeFr(d: PeriodeAffichable): string {
  const suffixe = (v: string) => (v === 'matin' ? ' (matin)' : v === 'apres_midi' ? ' (après-midi)' : '');
  if (d.date_debut === d.date_fin) {
    const entier = d.debut_demi === 'matin' && d.fin_demi === 'apres_midi';
    const moitie = entier ? 'journee' : d.debut_demi === 'journee' ? d.fin_demi : d.debut_demi;
    return `${dateFr(d.date_debut)}${suffixe(moitie)}`;
  }
  return `${dateFr(d.date_debut)}${suffixe(d.debut_demi)} → ${dateFr(d.date_fin)}${suffixe(d.fin_demi)}`;
}
